import React from 'react';
import { ProductsBanner } from 'src/modules/products/components//ProductsBanner';
import { StickyMenuProvider } from 'src/components/common/StickyMenu/StickyMenuContext';
import { MetaTitle } from 'src/components/seo/MetaTitle';
import { useTranslate } from 'react-t7e';
import { MetaDescription } from 'src/components/seo/MetaDescription';
import { ProductsLegalMentions } from 'src/modules/products/components/ProductsLegalMentions';
import { VendorGetServerSideProps } from 'vendor/utils/VendorGetServerSideProps';
import { configureSSR } from 'src/utils/configureSSR';
import { ProductsInfoSection } from 'src/modules/products/components/ProductsInfoSection';
import { ProductCategoryCode } from 'src/models/pim';
import cosmeceuticalsImage from 'src/modules/products/assets/cosmeceuticals/heading-image.png';
import fillersImage from 'src/modules/products/assets/fillers/heading-image.jpg';
import { fetchProductsListQuery } from 'src/modules/products/hooks/useProductsListQuery';

const ProductsPage = () => {
  const { _ } = useTranslate();

  return (
    <>
      <MetaTitle>{_('Products - Fillers, Devices, Cosmeceuticals')}</MetaTitle>
      <MetaDescription>
        {_(
          'Discover Neauvia products. PEG-HA fillers, energy-based devices and advanced cosmeceutical line range of products for the aesthetic and surgical markets',
        )}
      </MetaDescription>

      <StickyMenuProvider>
        <ProductsBanner />
        <ProductsInfoSection
          category={ProductCategoryCode.Fillers}
          title={_('fillers')}
          description={_(
            'Neauvia HA fillers* are based on a unique cross linker technology SMART CROSSLINKING TECHNOLOGY – with PEG, that gives our products a high safety and tolerability profile and that allows our fillers to perfectly integrate into the various anatomical planes.',
          )}
          image={fillersImage}
          threshold={{
            desktop: 0.4,
            mobile: 0.8,
          }}
        />
        <ProductsInfoSection
          category={ProductCategoryCode.Devices}
          title={_('devices')}
          description={_(
            'Neauvia provides an energy-based range of products** for the aesthetic and surgical markets. Neauvia devices are characterized by sleek, modern design and advanced electromedical engineering in related fields such as electrosurgical, radiofrequency treatment, thermal-lifting, skin photo-biostimulation and cosmetology.',
          )}
          noOfColumns={4}
        />
        <ProductsInfoSection
          category={ProductCategoryCode.Cosmeceuticals}
          title={_('cosmeceuticals')}
          description={_('cosmeceuticals.description')}
          image={cosmeceuticalsImage}
          threshold={{
            desktop: 0.2,
            mobile: 0.8,
          }}
        />

        <ProductsLegalMentions />
      </StickyMenuProvider>
    </>
  );
};

export const getServerSideProps = VendorGetServerSideProps((ctx) =>
  configureSSR(ctx, {
    layout: {
      variant: 'default',
      tvbar: true,
    },
    cacheControl: {
      maxAge: 900,
      sMaxAge: 3600,
    },
    actions: {
      common: () => [
        ctx.queryClient.prefetchQuery(
          fetchProductsListQuery(ctx.apis, {
            filter: {
              categories: {
                categories_code: { _eq: ProductCategoryCode.Fillers },
              },
            },
          }),
        ),
        ctx.queryClient.prefetchQuery(
          fetchProductsListQuery(ctx.apis, {
            filter: {
              categories: {
                categories_code: { _eq: ProductCategoryCode.Cosmeceuticals },
              },
            },
          }),
        ),
        ctx.queryClient.prefetchQuery(
          fetchProductsListQuery(ctx.apis, {
            filter: {
              categories: {
                categories_code: { _eq: ProductCategoryCode.Devices },
              },
            },
          }),
        ),
      ],
    },
  }),
);

export default ProductsPage;
